import { Injectable, Inject } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { DOCUMENT } from '@angular/common';

export interface UserLogin {
  Email: string;
  Password: string;
}

export interface UserAccessToken {
  AccessToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private currentUserSubject = new BehaviorSubject<User>({} as User);
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  public isUserAdmin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserVendor: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserEmployee: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public isUserSm: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserEn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserHr: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserFn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserIt: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserQa: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserPm: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserAd: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserEhs: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isUserMt: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService, @Inject(DOCUMENT) private document: Document) {
    this.populateUserData();
  }


  registerUser(user: User) {
    // const body: User = {
    //   Email: user.Email,
    //   Password: user.Password,
    //   ConfirmPassword: user.ConfirmPassword,
    //   PhoneNumber: user.PhoneNumber,
    //   Address: user.Address,
    //   userType: user.userType,
    //   FullName: user.FullName,
    //   VendorCode: user.VendorCode,
    //   type: user.type,
    //   IsActive: user.IsActive,
    //   CreatedBy: user.CreatedBy,
    //   CreatedOn: user.CreatedOn,
    //   UpdatedBy: user.UpdatedBy,
    //   UpdatedOn: user.UpdatedOn,
    //   RegisterCode: user.RegisterCode,
    //   Error: user.Error
    // }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http.post(this.rootUrl + '/api/Account/Register', user, requestOptions);

  }

  userAuthentication(userName, password) {

    let userLogin: UserLogin = {
      Email: userName,
      Password: password
    };

    var data = "Email=" + userName + "&Password=" + password;

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded' });
    return this.http.post(this.rootUrl + '/api/Account/Login', userLogin, requestOptions);

  }

  setAuth(user: User) {
    //Set Loggedin status to true in data sharing 
    this.dataSharingService.isUserLoggedIn.next(true);
    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);

    if (user.userType == "1" && user.type == "Admin") {
      this.isUserAdmin.next(true);
    } else if (user.userType == "2" && user.type == "Employee") {
      this.isUserVendor.next(true);
    }
    else if (user.userType == "3" && user.type == "HR") {
      this.isUserHr.next(true);
    }
    else { }

  }

  populateUserData() {
    if (localStorage.getItem("userToken") != null) {
      var accessTokens = localStorage.getItem("userToken");
      this.getCurrentUserData(accessTokens).subscribe((data: any) => {
        if (data.accessToken != null && data != "false") {
          //localStorage.setItem('userToken', data.accessToken);
          //this.jwtService.saveToken(data.accessToken);
          this.setAuth(data);
        }
        else {

        }

      },
        (err: HttpErrorResponse) => {

        });

    }
    else {

    }
  }

  getCurrentUserData(accessTokens) {

    let acesTokn: UserAccessToken = {
      AccessToken: accessTokens
    };

    var data = "AccessToken=" + accessTokens;

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded' });
    return this.http.post(this.rootUrl + '/api/Account/getCurrentUserData', acesTokn, requestOptions);
    //return this.http.get(this.rootUrl + '/api/Account/getCurrentUserData');


  }

  purgeAuth() {

    this.dataSharingService.isUserLoggedIn.next(false);
    // Remove JWT from localstorage 
    this.jwtService.destroyToken();

    this.jwtService.destroyCookie();
    // Set current user to an empty object
    this.currentUserSubject.next({} as User);
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);

    this.isUserAdmin.next(false);
    this.isUserEmployee.next(false);
    this.isUserVendor.next(false);
    this.isUserHr.next(false);

  }
  getUsersData() {
    return this.http.get(this.rootUrl + '/api/account/getUsersData');
  }

  resetpassword(form) {
    return this.http.post(this.rootUrl + '/api/account/ResetPassword', form);
  }
  getUserProfile() {
    return this.http.get(this.rootUrl + '/api/account/getUserProfile');
  }
  EditSiteUser(id) {

    const user = {
      userId: id
    }
    return this.http.post(this.rootUrl + '/api/account/editSiteUser', user);
  }
  submitSiteUserForm(form) {
    return this.http.post(this.rootUrl + '/api/account/submitSiteUserForm', form);
  }

  editSiteUserProfile(form) {
    return this.http.post(this.rootUrl + '/api/account/editSiteUserProfile', form);
  }

  login() {
    this.document.location.href = this.rootUrl + "/api/account/SignInWithGoogle";
  }

  RemoveSiteUser(id) {
    const user = {
      userId: id
    }
    return this.http.post(this.rootUrl + '/api/account/RemoveSiteUser', user);
  }

  deleteSiteUser(id) {
    const user = {
      userId: id
    }
    return this.http.post(this.rootUrl + '/api/account/DeleteSiteUser', user);
  }

  ForgotPassword(user) {
    // const user = {
    //   email: emailid
    // }

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'No-Auth': 'True'
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };


    return this.http.post(this.rootUrl + '/api/Account/ForgotPassword', user, requestOptions);
  }

  filterUsers(keywrd){
    const key = {
      keyword : keywrd
    }
    return this.http.post(this.rootUrl + '/api/Account/FilterUsers', key);
  }

}

